module.exports = __webpack_public_path__ + "img/1459804164.ad592e76.jpg";